var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLeftArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.39935 7.60104C0.0674042 7.26909 0.0674042 6.7309 0.39935 6.39896L5.80872 0.98959C6.14066 0.657645 6.67885 0.657645 7.0108 0.98959C7.34274 1.32154 7.34274 1.85973 7.0108 2.19167L3.05247 6.15H23.0004V7.85H3.05247L7.0108 11.8083C7.34274 12.1403 7.34274 12.6785 7.0108 13.0104C6.67885 13.3424 6.14066 13.3424 5.80872 13.0104L0.39935 7.60104Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLeftArr);
export default __webpack_public_path__ + "static/media/MobileLeftArr.10da6539.svg";
export { ForwardRef as ReactComponent };